<template>
    <div
        class="ribbon-button"
        :class="{active: active, disabled: disabled}"
        @click="clicked"
    >
        <div class="ribbon-button-image">
            <img :src="image" :alt="text">
        </div>
        <div
            class="ribbon-button-text"
            :class="{condensed: condensed >= 2, slim: condensed === 1 || condensed === 3}"
        >{{ text }}</div>
    </div>
</template>

<script>
    export default {
        name: "RibbonButton",
        props: {
            text:     String,
            image:    String,
            click:    Function,
            active:   Boolean,
            disabled: Boolean,
            condensed: {
                type:    Number,
                default: 2
            }
        },
        methods: {
            clicked: function() {
                if (!this.disabled) {
                    this.$emit('clicked');
                }
            }
        }
    }
</script>

<style scoped>

    div.ribbon-button {
        width: 72px;
        display: inline-block;
        padding: 8px 4px;
        margin: 0 4px;
        height: 72px;
        text-align: center;
        vertical-align: bottom;
    }

    div.ribbon-button.active {
        background-color: var(--sc-blue-dark-5-percent);
        border-bottom: 2px solid var(--sc-blue-dark);
    }

    div.ribbon-button.disabled {
        opacity: 0.35;
    }

    div.ribbon-button:hover {
        background-color: var(--sc-blue-dark-5-percent);
    }
    div.ribbon-button.disabled:hover {
        background-color: transparent;
    }

    div.ribbon-button-image {
        height: 24px;
    }

    div.ribbon-button-text {
        width: 72px;
        height: 40px;
        font-size: 10pt;
        display: table-cell;
        vertical-align: middle;
        letter-spacing: 0.5px;
    }

    div.condensed {
        font-family: D-DIN Condensed, monospace, sans-serif;
    }

    div.slim {
        letter-spacing: unset;
    }

</style>